/**
 * Elegant CT monogram — clean serif "CT" inside a circular emerald disc with gold accents.
 * Designed for the cream-emerald-gold palette.
 */
import React from "react";

export default function BrandLogo({
  size = 42,
  variant = "default",
  className = "",
  ariaLabel = "Terapeut Georgiana — logo",
}) {
  // variant "gold" = inverted (cream disc, emerald text, gold ring)
  const ring = variant === "gold" ? "var(--ct-emerald, #0D1B2A)" : "var(--ct-gold, #D4AF37)";
  const disc = variant === "gold" ? "var(--ct-surface, #FFFFFF)" : "var(--ct-emerald, #0D1B2A)";
  const letter = variant === "gold" ? "var(--ct-emerald, #0D1B2A)" : "var(--ct-gold, #D4AF37)";
  const accent = "var(--ct-gold, #D4AF37)";

  return (
    <svg
      role="img"
      aria-label={ariaLabel}
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      style={{ display: "inline-block" }}
    >
      {/* Outer gold ring with subtle inner ring */}
      <circle cx="32" cy="32" r="31" fill={disc} stroke={ring} strokeWidth="2" />
      <circle cx="32" cy="32" r="27.5" fill="none" stroke={ring} strokeOpacity="0.5" strokeWidth="0.6" />

      {/* Top decorative arc dot */}
      <circle cx="32" cy="4.5" r="1.6" fill={accent} />
      {/* Bottom decorative arc dot */}
      <circle cx="32" cy="59.5" r="1.6" fill={accent} />

      {/* CT monogram — composed of two clean letter shapes */}
      <g>
        {/* C — open arc on the right, serif terminations */}
        <text
          x="32"
          y="44"
          textAnchor="middle"
          fontFamily="'Playfair Display', 'Cormorant Garamond', Georgia, serif"
          fontWeight="500"
          fontSize="36"
          fill={letter}
          style={{ letterSpacing: "-0.04em" }}
        >
          CT
        </text>
      </g>
    </svg>
  );
}
